import { useApi } from '@/api/ApiProvider';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

type useFetchNotificationsProps = {
  refetchInterval?: number;
};

const useFetchNotifications = ({ refetchInterval }: useFetchNotificationsProps = {}) => {
  const { fetchApi } = useApi();

  const [pollingEnabled, setPollingEnabled] = useState(true);

  const query = useQuery(['feeds/notifications'], () => fetchApi(['feeds']), {
    refetchInterval: () => {
      const _refetchInterval = refetchInterval ?? 120 * 1000;
      return pollingEnabled ? _refetchInterval : false;
    },
    refetchIntervalInBackground: false,
  });

  const enable = () => setPollingEnabled(true);

  const disable = () => setPollingEnabled(false);

  return {
    query,
    enableFeeds: enable,
    disableFeeds: disable,
  };
};

export default useFetchNotifications;
